// src/app/components/Moodle/MoodleRegistrationDialog.jsx
import React from 'react';

const MoodleRegistrationDialog = ({ user, registerUrl, onClose, onRegister }) => {
  // OBTENER DATOS DEL USUARIO (puede ser el objeto completo o solo los datos)
  const firstName = user?.firstName || user?.UserComplemento?.primer_nome || user?.primer_nome || '';
  const lastName = user?.lastName || user?.UserComplemento?.primer_apelido || user?.primer_apelido || '';
  const email = user?.email || '';
  const documentId = user?.documentId || user?.UserComplemento?.numero_doc || user?.numero_doc || '';

  console.log('[MoodleRegistrationDialog] Datos a mostrar:', { firstName, lastName, email, documentId });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h3 className="text-xl font-bold mb-4 text-[#1a237e]">Registro en Moodle</h3>
        
        <p className="mb-4 text-gray-700">
          No tienes un usuario en la plataforma de formación virtual.
          Para acceder, debes registrarte en Moodle.
        </p>

        <div className="bg-gray-100 rounded p-4 mb-4">
          <p className="font-semibold mb-2 text-gray-700">Datos que serán precargados:</p>
          <div className="space-y-1 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Nombre:</span>
              <span className="font-medium">{firstName || 'No disponible'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Apellido:</span>
              <span className="font-medium">{lastName || 'No disponible'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Email:</span>
              <span className="font-medium">{email || 'No disponible'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Documento:</span>
              <span className="font-medium">{documentId || 'No disponible'}</span>
            </div>
          </div>
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded p-3 mb-4 text-sm text-yellow-800">
          <strong>Nota:</strong> Estos datos no serán editables en el formulario de Moodle.
        </div>

        <div className="flex justify-end gap-3">
          <button 
            onClick={onClose} 
            className="btn btn-secondary"
          >
            Cancelar
          </button>
          <button 
            onClick={onRegister} 
            className="btn btn-primary btn-lg btn-block mt-2"
          >
            Registrarse en Moodle
          </button>
        </div>
      </div>
    </div>
  );
};

export default MoodleRegistrationDialog;